import store from '../store';
import { USER_ROLES } from '../common/constants';

export function homeGuard(to, from, next) {
  const user = store.getters['auth/getLoggedInUser'];
  if (user && user.role === USER_ROLES.SUPER_ADMIN) {
    next({ name: 'manage-schools' });
  } else {
    next({ name: 'contacts-list' });
  }
}
